<div class="min-h-[80vh] w-full bg-[#f1f2f3]">
  <div class="w-full bg-[#001847] h-[370px] relative" id="mask-image">
    <div class="container">
      <div class="w-full text-center relative  float-end mt-5 h-[360px]">
        <h1 class="text-white fw-medium fs-3 m-0 pb-2 mb-1   mt-5">ایران هتل
        </h1>
        <h2 class="text-white fs-1.6">هتل های زنجیره ای</h2>
   
      </div>

    </div>
  </div>
  <div class="container">
    <div class="w-full  mt-10">
      <nav>
        <ol class="breadcrumb-wrapper flex-wrap flex items-center gap-2">
          <li [ngClass]="last ? 'pointer-events-none' : 'cursor-pointer'"
            *ngFor="let bread of listBreadcrumb; let last = last; let index = index;let first = first">
            <ng-container *ngIf="!last">
              <a [href]="first ? '/' : bread['@id']">
                {{ bread.name }}
              </a>
            </ng-container>
            <ng-container *ngIf="last">
              <span class=""> {{ bread.name }} </span>
            </ng-container>

          </li>
        </ol>
      </nav>   
    </div>
   <div class="w-full  mt-10">
    <ul class="list-unstyled flex flex-wrap justify-start items-center gap-6 pb-10">
      <li class="grayscale hover:grayscale-0" *ngFor="let item of data">
        <a [href]="item.Url"
          class="flex h-[125px] w-[125px] justify-content-center">
          <img [src]="item.PictureUrl"
            [alt]="item.PictureName" width="125" height="125"
            class="d-block w-auto mw-100 h-auto mh-100 ls-is-cached lazyloaded" loading="lazy">
        </a>
      </li>
      </ul>
   </div>
  </div>

</div>